import { useMemo } from "react";
import * as Styled from "./style";
import { useRouter } from "next/router";
import { URL } from "~/components/blocks/layout/global-navi/const/url";
import type { UserMenusType } from "~/components/blocks/layout/global-navi/const/user-menus";
import { USER_MENUS } from "~/components/blocks/layout/global-navi/const/user-menus";
import { useClient } from "~/hooks/use-client";
import { useAuth } from "~/provider/auth";
import { uriConverter } from "~/util/uri-converter";

type MenuListProps = {
  userMenuType: UserMenusType;
  onHideUserMenu: () => void;
};
export const MenuList = ({ userMenuType, onHideUserMenu }: MenuListProps) => {
  const router = useRouter();
  const { isLoggedIn } = useAuth();
  const isClient = useClient();
  const userMenuList = useMemo(() => USER_MENUS[userMenuType], [userMenuType]);

  const currentUrl = isClient ? location.href : `${process.env.NEXT_PUBLIC_FRONT_URL}${router.asPath}`;
  const backUrl = uriConverter.encode(currentUrl);
  const redirectUrl = `${URL.logout}${backUrl}`;
  const registerUrl = `${URL.register}${backUrl}`;
  const loginUrl = `${URL.login}${backUrl}`;

  return (
    <Styled.DivContainer>
      <Styled.ULListWrapper>
        {userMenuList.menus.map((menu) => {
          const getHref = () => {
            switch (menu.type) {
              case "dmm-tv-link":
                return menu.url;
              case "platform-link":
                return menu.url;
              case "redirect":
                return redirectUrl;
            }
          };

          return (
            <li key={menu.title}>
              <a href={getHref()} aria-label="userMenuItem">
                {menu.title}
              </a>
            </li>
          );
        })}
        {!isLoggedIn && (
          <>
            <li>
              <a
                href={registerUrl}
                onClick={() => {
                  onHideUserMenu();
                }}
              >
                会員登録
              </a>
            </li>
            <li>
              <a
                href={loginUrl}
                onClick={() => {
                  onHideUserMenu();
                }}
              >
                ログイン
              </a>
            </li>
          </>
        )}
      </Styled.ULListWrapper>
    </Styled.DivContainer>
  );
};
